import { Component, Input, OnInit } from "@angular/core";
import { SummaryTableProposal } from "../summary-table.component";

@Component({
  selector: "app-summary-table-expanded",
  templateUrl: "./summary-table-expanded.component.html",
})
export class SummaryTableExpandedComponent implements OnInit {
  @Input() key: string;
  @Input() proposals?: SummaryTableProposal[] = [];

  hasAlcadaAnalise = false;
  hasAlcadaAprovacao = false;

  public orderby: string = "LeadTime";
  public sort: string = "asc";

  ngOnInit(): void {
    this.handleOptionalFields();
  }

  private setOrder(orderby) {
    if (this.orderby != orderby) {
      this.sort = "asc";
    } else {
      this.sort = this.sort == "asc" ? "desc" : "asc";
    }
    this.orderby = this.orderby != orderby ? orderby : this.orderby;
    this.OrderResults();
  }

  private OrderResults() {
    if(!this.proposals) return;

    if (this.orderby === 'Codigo' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Codigo > b.Codigo) ? 1 : ((b.Codigo > a.Codigo) ? -1 : 0));
    }
    else if (this.orderby === 'Codigo' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Codigo > a.Codigo) ? 1 : ((a.Codigo > b.Codigo) ? -1 : 0));
    }
    if (this.orderby === 'Nome' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Nome > b.Nome) ? 1 : ((b.Nome > a.Nome) ? -1 : 0));
    }
    else if (this.orderby === 'Nome' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Nome > a.Nome) ? 1 : ((a.Nome > b.Nome) ? -1 : 0));
    }
    if (this.orderby === 'GC' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.GC > b.GC) ? 1 : ((b.GC > a.GC) ? -1 : 0));
    }
    else if (this.orderby === 'GC' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.GC > a.GC) ? 1 : ((a.GC > b.GC) ? -1 : 0));
    }
    if (this.orderby === 'CTC' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.CTC > b.CTC) ? 1 : ((b.CTC > a.CTC) ? -1 : 0));
    }
    else if (this.orderby === 'CTC' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.CTC > a.CTC) ? 1 : ((a.CTC > b.CTC) ? -1 : 0));
    }
    if (this.orderby === 'Representante' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Representante > b.Representante) ? 1 : ((b.Representante > a.Representante) ? -1 : 0));
    }
    else if (this.orderby === 'Representante' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Representante > a.Representante) ? 1 : ((a.Representante > b.Representante) ? -1 : 0));
    }
    if (this.orderby === 'Status' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Status > b.Status) ? 1 : ((b.Status > a.Status) ? -1 : 0));
    }
    else if (this.orderby === 'Status' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Status > a.Status) ? 1 : ((a.Status > b.Status) ? -1 : 0));
    }
    if (this.orderby === 'Valor' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Valor > b.Valor) ? 1 : ((b.Valor > a.Valor) ? -1 : 0));
    }
    else if (this.orderby === 'Valor' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Valor > a.Valor) ? 1 : ((a.Valor > b.Valor) ? -1 : 0));
    }
    if (this.orderby === 'LeadTime' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.LeadTime > b.LeadTime) ? 1 : ((b.LeadTime > a.LeadTime) ? -1 : 0));
    }
    else if (this.orderby === 'LeadTime' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.LeadTime > a.LeadTime) ? 1 : ((a.LeadTime > b.LeadTime) ? -1 : 0));
    }
    if (this.orderby === 'Responsavel' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.Responsavel > b.Responsavel) ? 1 : ((b.Responsavel > a.Responsavel) ? -1 : 0));
    }
    else if (this.orderby === 'Responsavel' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.Responsavel > a.Responsavel) ? 1 : ((a.Responsavel > b.Responsavel) ? -1 : 0));
    }
    if (this.orderby === 'AlcadaAnalise' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.AlcadaAnalise > b.AlcadaAnalise) ? 1 : ((b.AlcadaAnalise > a.AlcadaAnalise) ? -1 : 0));
    }
    else if (this.orderby === 'AlcadaAnalise' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.AlcadaAnalise > a.AlcadaAnalise) ? 1 : ((a.AlcadaAnalise > b.AlcadaAnalise) ? -1 : 0));
    }
    if (this.orderby === 'AlcadaAprovacao' && this.sort === 'asc') {
      this.proposals.sort((a, b) => (a.AlcadaAprovacao > b.AlcadaAprovacao) ? 1 : ((b.AlcadaAprovacao > a.AlcadaAprovacao) ? -1 : 0));
    }
    else if (this.orderby === 'AlcadaAprovacao' && this.sort === 'desc') {
      this.proposals.sort((a, b) => (b.AlcadaAprovacao > a.AlcadaAprovacao) ? 1 : ((a.AlcadaAprovacao > b.AlcadaAprovacao) ? -1 : 0));
    }
  }

  private handleOptionalFields(): void { 
    if(!this.proposals) return;
    if(this.proposals.find(proposal => !!proposal.AlcadaAnalise)){
      this.hasAlcadaAnalise = true;
    }

    if(this.proposals.find(proposal => !!proposal.AlcadaAprovacao)){
      this.hasAlcadaAprovacao = true;
    }
    this.OrderResults();
  }
}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/summary-table/summary-table-expanded/summary-table-expanded.component.ts